<template>
  <div v-if="props.productTopFeatures.length > 0" class="bg-white">
    <h1
      v-if="!props.hasProductIntroduction"
      id="topFeatures"
      :class="!props.hasProductIntroduction ? 'mt-16' : ''"
      class="text-2xl md:text-[32px] lg:text-[38px] xl:text-[42px] text-[#404040] text-center uppercase font-bold break-words px-4 py-6 lg:py-12"
    >
      {{ $t("common.top_features") }}
    </h1>
    <div
      :id="props.hasProductIntroduction ? 'topFeatures' : ''"
      class="flex flex-col items-stretch"
    >
      <div
        v-for="(tp, tpIndex) in props.productTopFeatures"
        :key="tpIndex"
        class="flex flex-col overflow-hidden md:flex-row"
      >
        <div
          :class="[tpIndex % 2 === 0 ? 'md:order-0' : ' md:order-1']"
          :data-aos="tpIndex % 2 === 0 ? 'fade-right' : 'fade-left'"
          class="bg-[#F9F9F9] flex md:w-2/4 h-[300px] sm:h-[400px] md:h-[550px] overflow-hidden"
          data-aos-delay="100"
        >
          <video
            v-if="tp.video"
            class="object-cover w-full xyz-nested"
            :poster="
              tp.cover && tp.cover[0] ? tp.cover && tp.cover[0].url_md : null
            "
            loop
            preload="metadata"
            playsinline
            xyz="fade small delay-5"
            muted
          >
            <source :src="tp.video" />
          </video>
          <img
            v-else-if="tp.cover && tp.cover[0]"
            :src="tp.cover[0].url_hd"
            class="self-center object-cover w-full h-full max-w-full xyz-nested"
            xyz="fade small delay-5"
          />
        </div>
        <div
          :class="
            tpIndex % 2 === 0 ? 'md:text-right' : 'bg-[#0f0f0f] text-white'
          "
          :data-aos="tpIndex % 2 === 0 ? 'fade-left' : 'fade-right'"
          class="flex flex-col justify-center md:w-2/4 h-full md:h-[550px] overflow-hidden px-4 py-8"
          data-aos-delay="50"
        >
          <div class="w-full py-8 mx-auto md:px-0 lg:w-9/12 md:py-4">
            <span
              :class="tpIndex % 2 === 0 ? 'text-secondary-200' : ' text-white'"
              class="inline-block pb-1 mb-2 text-base font-bold lg:text-2xl"
              data-aos="fade"
              data-aos-delay="100"
              v-text="tp.title"
            />
            <br />
            <span
              class="text-[15px] leading-[24px] lg:leading-[32px] lg:text-xl"
              data-aos-delay="150"
              data-aos="fade"
            >
              {{ tp.text }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  productTopFeatures: {
    type: [Array, Object],
    required: true,
  },
  hasProductIntroduction: {
    type: Boolean,
    required: true,
  },
});
</script>
